window.sequencingRequestInitialise = () => {
    sequencingRequestShowConditionalFields();
};

window.sequencingRequestPlatformChanged = () => {
    sequencingRequestShowConditionalFields();
    sequencingRequestAdjustReadLengths();
};

window.sequencingRequestShowConditionalFields = () => {
    $(".conditional").hide()
    platform = $('#sequencing_request_platform :selected').text().toLowerCase().split(' ')[0].split('-')[0]
    $(".conditional.".concat(platform)).show()
};

window.sequencingRequestAdjustReadLengths = () => {
    platform = $('#sequencing_request_platform :selected').text();
    if ( platform.match("NextSeq") || platform.match("HiSeq") || platform.match("MiSeq") || platform.match("NovaSeq") ) { // platform is illumina
        r = $('#sequencing_request_read_length').get(0);
        orig_read_length = r.value
        while(r.options.length) { r.remove(0); } // delete all the options
        options = r.options;
        options.length = 1;
        for (i = 0; i < read_lengths.length; ++i) {
            if (read_lengths[i][0] == platform) {
                options[options.length] = new Option(read_lengths[i][1]);
            }
        }
        r.value = orig_read_length // try to reselect the old read length
    }
}
